<template>
    <div class="settings-popup">
        <Popup :class-name="showPopup ? 'open' : ''" @closePopup="closePopup" data-app>
            <h4 class="popup-title">
                <svg class="ico" width="15" height="15">
                     <use xlink:href="#ico-menu-settings"></use>
                </svg>
                <span>Settings</span>
            </h4>
            <div class="popup-content content">
                <v-form @submit.prevent="handleSubmit" ref="form">
                    <div class="form-content">
                        <div v-if="initialized">
                            <span>BIC/FIC settings</span>
                            <v-divider class="mt-2"></v-divider>
                            <v-flex xs12>
                                <v-layout align-center class="mt-2">
                                    <ColorInput v-model="form.fic_color" :defaultValue="form.fic_color"></ColorInput>
                                    <label class="ml-2">First in Class (FIC)</label>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12>
                                <v-layout align-center class="mt-2">
                                    <ColorInput v-model="form.bic_color" :defaultValue="form.bic_color"></ColorInput>
                                    <label class="ml-2">Best In Class (BIC)</label>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12>
                                <v-layout align-center class="mt-2">
                                    <ColorInput v-model="form.fic_bic_color" :defaultValue="form.fic_bic_color"></ColorInput>
                                    <label class="ml-2">Both BIC/FIC</label>
                                </v-layout>
                            </v-flex>
                        </div>
                        <div class="loading" v-else>
                            <div>
                                <i class="fa fa-spinner fa-spin spinner"></i>
                            </div>
                            <span class="mt-2">Loading...</span>
                        </div>

                    </div>

                    <div class="buttons vertical mt-5">
                        <v-btn type="submit" class="popup-btn" :disabled="!initialized" :loading="loading">SAVE</v-btn>
                        <v-btn
                            type="button"
                            class="popup-btn secondary"
                            :disabled="loading"
                            @click="closePopup"
                            >CANCEL</v-btn
                        >
                    </div>
                </v-form>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from "../common/Popup.vue";
import ColorInput from "../common/ColorInput.vue";
import ValidationError from "../../utils/ValidationError";
import { bus } from '../../main';

export default {
    components: {
        Popup,
        ColorInput,
    },
    computed: {
        settings() {
            return this.$store.getters['setting/getAll'];
        },
        isSettingsInitialized() {
            return this.$store.getters['setting/getIsInitialized'];
        },
    },
    watch:{
        isSettingsInitialized(newVal, oldVal){
            if(newVal && !this.initialized){
                this.initialized = true;
                this.initForm();
            }
        },
    },
    data() {
        return {
            showPopup: false,
            form: {
                fic_color: null,
                bic_color: null,
                fic_bic_color: null,
            },
            errorsMessages: {},
            initialized: false,
            loading: false,
        };
    },
    created (){
        bus.$on('openSettingsPopup', async () => {
            await this.$nextTick(this.initForm);
            this.initialized = this.isSettingsInitialized;
            this.showPopup = true;
        });
    },
    methods: {
        initForm(){
            if(this.isSettingsInitialized){
                this.form = { ...this.settings };
                this.errorsMessages = {};
            }
        },
        async handleSubmit() {
            this.errorsMessages = {};

            // check if not modified
            if(
                this.settings.fic_color === this.form.fic_color
                && this.settings.bic_color === this.form.bic_color
                && this.settings.fic_bic_color === this.form.fic_bic_color
            ){
                this.closePopup();
                return;
            }

            try {
                this.loading = true;

                const settingsUpdated = await this.$store.dispatch("setting/update", {
                    ...this.form,
                });

                this.closePopup();

            } catch (error) {
                if (error instanceof ValidationError) {
                    this.errorsMessages = error.errors;
                } else {
                    console.error(error);
                    this.closePopup();
                }
            } finally {
                this.loading = false;
            }
        },
        closePopup() {
            this.showPopup = !this.showPopup;

            bus.$emit('settingsPopupClosed');
        }
    }
};
</script>

<style lang="scss">
@import "../../style/Charts/SettingsPopup";
</style>